import { render, staticRenderFns } from "./ReviewPanel.vue?vue&type=template&id=871e4c82&scoped=true"
import script from "./ReviewPanel.vue?vue&type=script&lang=ts"
export * from "./ReviewPanel.vue?vue&type=script&lang=ts"
import style0 from "./ReviewPanel.vue?vue&type=style&index=0&id=871e4c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871e4c82",
  null
  
)

export default component.exports